"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance"); }

function _iterableToArray(iter) { if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function includesTypeOrName(accept, type, name) {
  // an accepted type can be audio/*, video/*, image/*, any MIME type string or a file extension
  // see https://html.spec.whatwg.org/multipage/input.html#file-upload-state-(type=file)
  if (!accept) {
    return true;
  }

  var acceptedTypes = accept.split(',').map(function (t) {
    return t.trim();
  });

  if (acceptedTypes.length === 0) {
    return true;
  }

  return acceptedTypes.some(function (acceptedType) {
    if (acceptedType === 'audio/*' && type.indexOf('audio/') === 0) {
      return true;
    }

    if (acceptedType === 'video/*' && type.indexOf('video/') === 0) {
      return true;
    }

    if (acceptedType === 'image/*' && type.indexOf('image/') === 0) {
      return true;
    }

    if (acceptedType.indexOf('.') === 0) {
      return name != null && name.indexOf(acceptedType) === name.length - acceptedType.length;
    }

    return type === acceptedType;
  });
}

function cancelEvent(e) {
  e.preventDefault();
  e.stopPropagation();
} // Declare global DataTransferItem for standardjs lintfix

/* global DataTransferItem */
// Browser supports webkitGetAsEntry API needed for dropping folders


var folderDropSupported = !!DataTransferItem.prototype.webkitGetAsEntry;

var DropAreaBase =
/*#__PURE__*/
function (_React$Component) {
  _inherits(DropAreaBase, _React$Component);

  function DropAreaBase() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, DropAreaBase);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(DropAreaBase)).call.apply(_getPrototypeOf2, [this].concat(args)));

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "fileInputRef", _react.default.createRef());

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "handleClick", function (e) {
      if (!_this.props.disabled) {
        if (_this.props.clickable) {
          _this.fileInputRef.current.click();
        }

        if (_this.props.onClick) {
          _this.props.onClick(e);
        }
      }
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "handleDragStart", function (e) {
      e.dataTransfer.effectAllowed = 'copyMove';
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "handleDragEnter", function (e) {
      cancelEvent(e);

      if (_this.isAcceptingTransfer(e.dataTransfer)) {
        e.dataTransfer.dropEffect = 'copy';

        if (_this.props.onAcceptedDragEnter) {
          _this.props.onAcceptedDragEnter(e);
        }
      } else {
        e.dataTransfer.dropEffect = 'none';
      }
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "handleDragOver", function (e) {
      cancelEvent(e);

      if (_this.isAcceptingTransfer(e.dataTransfer)) {
        e.dataTransfer.dropEffect = 'copy';
      } else {
        e.dataTransfer.dropEffect = 'none';
      }
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "handleDrop", function (e) {
      cancelEvent(e);

      if (_this.props.onDrop) {
        _this.props.onDrop(e);
      }

      if (_this.isAcceptingTransfer(e.dataTransfer)) {
        if (folderDropSupported === false) {
          _this.props.onSelectFiles(e.dataTransfer.files);
        } else {
          // Recursive function to walk into directories and extract file objects
          var recurseItem = function recurseItem(item, sub) {
            return new Promise(function (resolve, reject) {
              // Resolve with a single item list
              if (item.isFile) {
                item.file(function (file) {
                  return resolve([file]);
                }, function (e) {
                  return reject(e);
                });
              } // Resolve with merging all sub entry lists


              if (item.isDirectory) {
                item.createReader().readEntries(function (entries) {
                  return Promise.all(entries.map(function (entry) {
                    return recurseItem(entry, sub + item.name + '/');
                  })).then(function (files) {
                    return files.flat();
                  }).then(function (files) {
                    return resolve(files);
                  });
                }, function (err) {
                  return reject(err);
                });
              }
            });
          };

          Promise.all(_toConsumableArray(e.dataTransfer.items).map(function (item) {
            return recurseItem(item.webkitGetAsEntry(), '/');
          })).then(function (files) {
            return files.flat();
          }).then(function (files) {
            return _this.props.onSelectFiles(files);
          });
        }
      }
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "handleSelectFiles", function (e) {
      _this.props.onSelectFiles(e.target.files);
    });

    return _this;
  }

  _createClass(DropAreaBase, [{
    key: "isAcceptingTransfer",
    value: function isAcceptingTransfer(dataTransfer) {
      if (!this.props.disabled && (dataTransfer.items.length === 1 || this.props.multiple)) {
        if (dataTransfer.items.length > dataTransfer.files.length) {
          // drag event (no files) or some elements are not files
          var _iteratorNormalCompletion = true;
          var _didIteratorError = false;
          var _iteratorError = undefined;

          try {
            for (var _iterator = dataTransfer.items[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
              var item = _step.value;

              if (item.kind !== 'file' || !includesTypeOrName(this.props.accept, item.type)) {
                return false;
              }
            }
          } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
              }
            } finally {
              if (_didIteratorError) {
                throw _iteratorError;
              }
            }
          }
        } else {
          // drop event
          if (dataTransfer.files.length === 0) {
            return false;
          }

          var _iteratorNormalCompletion2 = true;
          var _didIteratorError2 = false;
          var _iteratorError2 = undefined;

          try {
            for (var _iterator2 = dataTransfer.files[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
              var file = _step2.value;

              if (!includesTypeOrName(this.props.accept, file.type, file.name)) {
                return;
              }
            }
          } catch (err) {
            _didIteratorError2 = true;
            _iteratorError2 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion2 && _iterator2.return != null) {
                _iterator2.return();
              }
            } finally {
              if (_didIteratorError2) {
                throw _iteratorError2;
              }
            }
          }
        }

        return true;
      }

      return false;
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          accept = _this$props.accept,
          children = _this$props.children,
          clickable = _this$props.clickable,
          Component = _this$props.component,
          disabled = _this$props.disabled,
          multiple = _this$props.multiple,
          onAcceptedDragEnter = _this$props.onAcceptedDragEnter,
          onSelectFiles = _this$props.onSelectFiles,
          other = _objectWithoutProperties(_this$props, ["accept", "children", "clickable", "component", "disabled", "multiple", "onAcceptedDragEnter", "onSelectFiles"]);

      return _react.default.createElement(Component, _extends({}, other, {
        onDragStart: this.handleDragStart,
        onDragEnter: this.handleDragEnter,
        onDrop: this.handleDrop,
        onDragOver: this.handleDragOver,
        onDragEnd: cancelEvent,
        onClick: this.handleClick
      }), children, clickable && _react.default.createElement("input", {
        accept: accept,
        multiple: multiple,
        onChange: this.handleSelectFiles,
        ref: this.fileInputRef,
        style: {
          display: 'none'
        },
        type: "file"
      }));
    }
  }]);

  return DropAreaBase;
}(_react.default.Component);

exports.default = DropAreaBase;
DropAreaBase.propTypes = {
  /**
   * The accepted file types as a comma-separated list of MIME types or file extensions.
   * If not set, any file type will be accepted.
   */
  accept: _propTypes.default.string,

  /**
   * Used to render content in the drop area.
   */
  children: _propTypes.default.node,

  /**
   * If `true`, the drop area can be clicked to open a file selection dialog.
   */
  clickable: _propTypes.default.bool,

  /**
   * The component used for the root node.
   */
  component: _propTypes.default.elementType,

  /**
   * If `true`, the drop area will be disabled.
   */
  disabled: _propTypes.default.bool,

  /**
   * If `true`, the drop area will accept multiple files.
   */
  multiple: _propTypes.default.bool,

  /**
   * Callback fired when a user drags one or more accepted files over the drop area.
   */
  onAcceptedDragEnter: _propTypes.default.func,

  /**
   * Callback fired when the user clicks on the drop area.
   */
  onClick: _propTypes.default.func,

  /**
   * Callback fired when the user selects or drops one or more accepted files.
   */
  onSelectFiles: _propTypes.default.func.isRequired
};
DropAreaBase.defaultProps = {
  component: 'div'
};